import React, { PureComponent, Fragment } from 'react'
import { parse } from 'qs'

import config from 'config'

class ExternalActivityRoute extends PureComponent {

	componentDidMount() {
		const params = parse(this.props.location.search.substr(1))
		if (params.r) {
			const redirectUrl = `${config.ct_alt}redirect.php?url=${encodeURIComponent(params.r)}`
			window.location = redirectUrl
		}
	}

	render() {
		return (
			<Fragment />
		)
	}
}

export default ExternalActivityRoute
